import { Link } from "@tanstack/react-router";

export function SiteFooter() {
  return (
    <footer className="relative mt-32 px-6 pb-10">
      <div className="mx-auto max-w-7xl">
        <div className="text-foreground/25 mb-6">
          <div className="barcode-rule" />
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-mono uppercase tracking-[0.14em] text-muted-foreground">
          <div>© {new Date().getFullYear()} iMPLI Informations-Systeme GmbH</div>
          <div className="flex items-center gap-2">
            <Link to="/impressum" className="transition-colors hover:text-foreground">
              Impressum
            </Link>
            <span className="text-foreground/20">·</span>
            <Link to="/datenschutz" className="transition-colors hover:text-foreground">
              Datenschutz
            </Link>
            <span className="text-foreground/20">·</span>
            <span className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-accent" />
              Handgemacht von Mensch &amp; KI
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
